import React, { Component } from 'react';
import { func, shape, string, bool } from 'prop-types';
import { callOutline } from 'ionicons/icons';

import Field from '~components/Field/index';
import InputLabel from '~components/InputLabel';
import { getFormattedField } from '~utils/inputValidations';

class PhoneField extends Component {
  handleBlur = e => {
    const { onBlur, values, setFieldValue, fieldName } = this.props;
    const phone = values[fieldName];
    const formattedPhone = getFormattedField.phone(phone);

    if (phone !== formattedPhone) {
      setFieldValue(fieldName, formattedPhone);
    }

    onBlur(e);
  };

  render() {
    const { fieldName, icon, className, label } = this.props;

    return (
      <Field
        name={fieldName}
        component={InputLabel}
        inputType="tel"
        className={className}
        label={label}
        onBlur={this.handleBlur}
        {...(icon && { icon: callOutline })}
      />
    );
  }
}

PhoneField.defaultProps = {
  className: 'm-bottom-5'
};

PhoneField.propTypes = {
  fieldName: string.isRequired,
  setFieldValue: func.isRequired,
  onBlur: func.isRequired,
  className: string,
  icon: bool,
  label: string,
  values: shape({
    phone: string
  })
};

export default PhoneField;
